import { createStore } from 'vuex'

export default createStore({
  state: {
    theme: 'light',
    user: null,
    isAuthenticated: false
  },
  mutations: {
    setTheme(state, theme) {
      state.theme = theme
    },
    setUser(state, user) {
      state.user = user
      state.isAuthenticated = !!user
    }
  },
  actions: {
    updateTheme({ commit }, theme) {
      commit('setTheme', theme)
    },
    updateUser({ commit }, user) {
      commit('setUser', user)
    }
  },
  getters: {
    currentTheme: state => state.theme,
    currentUser: state => state.user,
    isAuthenticated: state => state.isAuthenticated
  }
}) 